// register env variables here with 1:1 .env
// this will allow to fetch env variables from other places

// this can be flatenned but don't have time
// i think eventually we should have just base domain/url
// in place and the paths/routes would stay the same
const replaceLocalhostWithTestDomain = (url) => {
  if (!url) return url
  return url.replace(
    /(localhost|127\.0\.0\.1)(:\d+)?/gi,
    (match, host, port = '') => `buzz-test.payready.com.local${port}`,
  )
}
const getApiEndpoints = () => {
  const hostname = window.location.hostname

  if (hostname === 'buzz-test.payready.com') {
    return {
      graphql: 'https://buzz-test-api.payready.com/api/v1/graphql',
      graphqlWs: 'wss://buzz-test-api.payready.com/api/v1/graphql',
      rest: 'https://buzz-test-api.payready.com/api/v1/rest',
      reporting: 'https://buzz-test-api.payready.com/reporting-api/',
    }
  } else if (hostname === 'buzz.payready.com') {
    return {
      graphql: 'https://buzz-api.payready.com/api/v1/graphql',
      graphqlWs: 'wss://buzz-api.payready.com/api/v1/graphql',
      rest: 'https://buzz-api.payready.com/api/v1/rest',
      reporting: 'https://buzz-api.payready.com/reporting-api/',
    }
  } else if (hostname === 'buzz-test.payready.com.local') {
    return {
      graphql: replaceLocalhostWithTestDomain(
        process.env.REACT_APP_GRAPHQL_API_ENDPOINT,
      ),
      graphqlWs: replaceLocalhostWithTestDomain(
        process.env.REACT_APP_GRAPHQL_API_WS_ENDPOINT,
      ),
      rest: replaceLocalhostWithTestDomain(
        process.env.REACT_APP_REST_API_ENDPOINT,
      ),
      reporting: replaceLocalhostWithTestDomain(
        process.env.REACT_APP_REPORTING_API_ENDPOINT,
      ),
    }
  } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Use relative URLs for localhost so Vite proxy handles cross-origin cookies
    return {
      graphql: '/api/v1/graphql',
      graphqlWs: `ws://${hostname}:${window.location.port}/api/v1/graphql`,
      rest: '/api/v1/rest',
      reporting: '/reporting-api/',
    }
  }

  // Default to environment variables for other hosts
  return {
    graphql: process.env.REACT_APP_GRAPHQL_API_ENDPOINT,
    graphqlWs: process.env.REACT_APP_GRAPHQL_API_WS_ENDPOINT,
    rest: process.env.REACT_APP_REST_API_ENDPOINT,
    reporting: process.env.REACT_APP_REPORTING_API_ENDPOINT,
  }
}

const apiEndpoints = getApiEndpoints()

const ENVIRONMENT_VARIABLES = {
  aws_region: process.env.REACT_APP_AWS_COGNITO_REGION,
  cognito_pool: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  cognito_identity_pool: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID,
  cognito_client: process.env.REACT_APP_AWS_COGNITO_APP_CLIENT_ID,
  cognito_domain: process.env.REACT_APP_AWS_COGNITO_DOMAIN,
  graphql_api_endpoint: apiEndpoints.graphql,
  graphql_api_endpoint_ws: apiEndpoints.graphqlWs,
  rest_api_endpoint: apiEndpoints.rest,
  reporting_api_endpoint: apiEndpoints.reporting,
  lambda_graphql_api_endpoint:
    process.env.REACT_APP_LAMBDA_GRAPHQL_API_ENDPOINT,
  env: process.env.REACT_ENV,
  session_pings_endpoint: process.env.REACT_APP_SESSION_PING_ENDPOINT,
  entrata_integration_id: process.env.REACT_APP_ENTRATA_INTEGRATION_ID,
  onesignal_app_id: process.env.REACT_APP_ONESIGNAL_APP_ID,
  onesignal_safari_web_id: process.env.REACT_APP_ONESIGNAL_SAFARI_WEB_ID,
  media_buket_name: process.env.REACT_APP_AWS_MEDIA_BUCKET_NAME,
  web_public_url: process.env.REACT_APP_WEB_PUBLIC_URL, //not to confuse with the URL of web_admin
  crisp_website_id: process.env.REACT_APP_CRISP_WEBSITE_ID,
  payready_base_url: process.env.REACT_APP_PAY_READY_BASE_URL,
  payready_client_id: process.env.REACT_APP_PAY_READY_CLIENT_ID,
  payready_redirect_uri: process.env.REACT_APP_PAY_READY_REDIRECT_URI,
  payready_only: process.env.REACT_APP_PAY_READY_ONLY,
  res_center_base_url: process.env.REACT_APP_RES_CENTER_BASE_URL,
  intercom_app_id: process.env.REACT_APP_INTERCOM_APP_ID,
}

export const env = (key: keyof typeof ENVIRONMENT_VARIABLES) => {
  return ENVIRONMENT_VARIABLES[key]
}

export const isRunningLocally = () => {
  const hostname = window.location.hostname

  return (
    ['development', 'dev', 'local'].includes(env('env') as string) ||
    hostname === '127.0.0.1' ||
    hostname === 'localhost' ||
    hostname === 'buzz-test.payready.com.local'
  )
}

export const isProd = ['buzz.payready.com', 'app.buzzcrs.com'].includes(
  window.location.hostname,
)

export const isProduction = () => {
  if (isProd) return true
  const e = env('env') ?? (typeof process !== 'undefined' && process.env?.NODE_ENV)
  if (typeof e !== 'string') return false
  const lower = e.toLowerCase()
  return lower === 'production' || lower === 'prod'
}

export const getAppDomain = () => {
  const domain = window.location.hostname
  const isPayReady =
    domain.endsWith('payready.com') ||
    domain.endsWith('payready.com.local') ||
    env('payready_only') === 'true'
  const isBuzz = !isPayReady
  return {
    isPayReady,
    isBuzz,
  }
}
